import React from 'react';
import { isDataLoaded } from '../../types/data-providers';
import { useLanguageLocale } from '../../hooks/language-locale-hooks';
import { GenericToolbar } from '../GenericToolbar';
import { DataIndicators } from '../DataIndicators';
import { useDeviceData } from '../../data/DataProviders/DeviceDataProvider';
import { AppRoute } from '../../routes';
import { pushAppRoute } from '../../data/domain/route-manager';
import { useHistory } from 'react-router-dom';
import { SignalRSiteDataProvider } from '../../data/DataProviders/SignalRSiteDataProvider';
import { Overview } from '../../app/insulgard/Overview';
import { TabBarMenu } from '../TabView/TabBar';
import { DeviceTab } from '../../types/device';
import { useGetOrganizationCheckDetails } from '../../data/DataProviders/GetOrgCheckProvider';

import { GetSiteSubscriptionProvider } from '../../data/DataProviders/GetSiteSubscriptionProvider';

type Props = {
    tabVal?: string;
    testId?: string;
    appRoute: AppRoute;
};

export const DeviceDetailPage: React.FC<Props> = (props) => {
    const Tbvalue =
        props.tabVal?.toLowerCase() === DeviceTab.sensorTrend.toLowerCase()
            ? 4
            : 0 || props.tabVal?.toLowerCase() === DeviceTab.phaseResolvedGraph.toLowerCase()
            ? 5
            : 0;
    const { t } = useLanguageLocale();
    const deviceData = useDeviceData();
    const history = useHistory();
    const getOrgCheckDetails = useGetOrganizationCheckDetails();
    const [getOrgTypeData, setgetOrgTypeData] = React.useState<any>();

    const [text, setText] = React.useState(Tbvalue);
    const setTab = (tabIndex: number): void => {
        setText(tabIndex);
        return;
    };

    const locationId =
        props.appRoute.type === 'OverviewSiteDevices' ||
        props.appRoute.type === 'DevicesLocation' ||
        props.appRoute.type === 'OverviewSite'
            ? props.appRoute.locationId
            : undefined;

    const title =
        (isDataLoaded(deviceData) &&
            isDataLoaded(deviceData.value.deviceProperties) &&
            deviceData.value.deviceProperties.value.name) ||
        '';
    const deviceId =
        (isDataLoaded(deviceData) &&
            isDataLoaded(deviceData.value.deviceProperties) &&
            deviceData.value.deviceProperties.value.id) ||
        '';

    const subtitle =
        isDataLoaded(deviceData) && isDataLoaded(deviceData.value.deviceProperties)
            ? deviceData.value.deviceProperties.value.siteName
            : '';

    const isEmpty = isDataLoaded(deviceData) && !deviceData.value.channelData && !deviceData.value.deviceProperties;
    React.useEffect(() => {
        if (isDataLoaded(getOrgCheckDetails)) {
            setgetOrgTypeData(getOrgCheckDetails.value);
        }
    }, [getOrgCheckDetails]);

    return (
        <div className="contentBox">
            <GenericToolbar
                showBackButton
                backButtonOnClick={(): void => {
                    pushAppRoute(history, props.appRoute);
                }}
                title={title}
                subtitle={subtitle}
            />

            {isDataLoaded(deviceData) && !isEmpty && isDataLoaded(deviceData.value.deviceProperties) && (
                <TabBarMenu
                    value={text}
                    setValue={setTab}
                    deviceVendor={deviceData.value.deviceProperties.value.type || ''}
                />
            )}

            <DataIndicators
                emptyIcon="Devices"
                emptyMessage={t('DASHBOARD.NO_DATA')}
                errorMessage={t('DASHBOARD.ERROR_LOADING_DATA')}
                data={deviceData}
                isEmpty={false}
            />

            {isDataLoaded(deviceData) && !isEmpty && (
                <>
                    <DataIndicators
                        emptyIcon="Devices"
                        emptyMessage={t('DASHBOARD.NO_DATA')}
                        errorMessage={t('DASHBOARD.ERROR_LOADING_DATA')}
                        data={deviceData.value.deviceProperties}
                        isEmpty={isEmpty}
                    />
                    {isDataLoaded(deviceData.value.deviceProperties) && (
                        <SignalRSiteDataProvider
                            siteId={deviceData.value.deviceProperties.value.siteId}
                            locationId={locationId}
                        >
                            <GetSiteSubscriptionProvider
                                siteId={deviceData.value.deviceProperties.value.siteId}
                                org={getOrgTypeData === undefined ? undefined : getOrgTypeData.isChamp}
                            >
                                <Overview
                                    deviceData={deviceData.value}
                                    tabIndex={text}
                                    appRoute={props.appRoute}
                                    deviceId={deviceId}
                                    testId={props.testId}
                                />
                            </GetSiteSubscriptionProvider>
                        </SignalRSiteDataProvider>
                    )}
                </>
            )}
        </div>
    );
};
